// client/src/components/Filters.jsx
import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

const Filters = ({ districts, filters, onApplyFilters, dateRange }) => {
    const [district, setDistrict] = useState(filters.district || 'all');
    const [role, setRole] = useState(filters.role || 'all');
    const [startDate, setStartDate] = useState(filters.startDate || '');
    const [endDate, setEndDate] = useState(filters.endDate || '');

    // Устанавливаем начальные даты при первом рендере
    useEffect(() => {
        if (dateRange?.min && dateRange?.max && !filters.startDate && !filters.endDate) {
            // Начало текущего года
            const currentYear = new Date().getFullYear();
            const startOfYear = `${currentYear}-01-01`;
            // Сегодняшняя дата
            const today = new Date().toISOString().split('T')[0];
            
            setStartDate(startOfYear);
            setEndDate(today);
        }
    }, [dateRange]);

    // Применяем фильтры мгновенно при любом изменении
    useEffect(() => {
        onApplyFilters({
            district,
            role,
            startDate,
            endDate
        });
    }, [district, role, startDate, endDate]);
    
    // Синхронизация с props при изменении
    useEffect(() => {
        setDistrict(filters.district || 'all');
        setRole(filters.role || 'all');
        setStartDate(filters.startDate || '');
        setEndDate(filters.endDate || '');
    }, [filters]);
    
    const handleReset = () => {
        const currentYear = new Date().getFullYear();
        const startOfYear = `${currentYear}-01-01`;
        const today = new Date().toISOString().split('T')[0];
        
        const resetFilters = {
            district: 'all',
            role: 'all',
            startDate: startOfYear,
            endDate: today
        };
        setDistrict(resetFilters.district);
        setRole(resetFilters.role);
        setStartDate(resetFilters.startDate);
        setEndDate(resetFilters.endDate);
    };
    
    return (
        <div className="card mb-3">
            <div className="card-body">
                <Row className="align-items-end g-3">
                    <Col md={3}>
                        <Form.Label className="fw-semibold">
                            <i className="bi bi-funnel me-1"></i> Район:
                        </Form.Label>
                        <Form.Select 
                            value={district} 
                            onChange={(e) => setDistrict(e.target.value)}
                        >
                            <option value="all">Все районы</option>
                            {districts.map((d, idx) => (
                                <option key={idx} value={d}>{d}</option>
                            ))}
                        </Form.Select>
                    </Col>
                    
                    <Col md={3}>
                        <Form.Label className="fw-semibold">
                            <i className="bi bi-person"></i> Роль:
                        </Form.Label>
                        <Form.Select 
                            value={role} 
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="all">Все роли</option>
                            <option value="student">Ученики</option>
                            <option value="teacher">Учителя</option>
                        </Form.Select>
                    </Col>
                    
                    <Col md={2}>
                        <Form.Label className="fw-semibold">
                            <i className="bi bi-calendar"></i> Дата с:
                        </Form.Label>
                        <Form.Control 
                            type="date" 
                            value={startDate} 
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </Col>
                    
                    <Col md={2}>
                        <Form.Label className="fw-semibold">
                            <i className="bi bi-calendar"></i> Дата по:
                        </Form.Label>
                        <Form.Control 
                            type="date" 
                            value={endDate} 
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </Col>
                    
                    <Col md={2}>
                        <Button variant="outline-secondary" onClick={handleReset} className="w-100">
                            <i className="bi bi-arrow-repeat"></i> Сбросить
                        </Button>
                    </Col>
                </Row>
                
                {(district !== 'all' || role !== 'all') && (
                    <div className="mt-2 pt-2 border-top">
                        <small className="text-muted">
                            <i className="bi bi-filters"></i> Активные фильтры:
                            {district !== 'all' && <span className="badge bg-primary ms-2">Район: {district}</span>}
                            {role !== 'all' && <span className="badge bg-success ms-2">Роль: {role === 'student' ? 'Ученики' : 'Учителя'}</span>}
                        </small>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Filters;